import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { BaseInput, IInputProps } from './Input.component';

export const DebouncedInput: FunctionComponent<IInputProps> = ({
  value: externalValue,
  onChange,
  debounceTime,
  defaultValue,
  ...props
}) => {
  const [value, setValue] = useState((defaultValue || externalValue) ?? '');

  const debouncedOnChange = useCallback(
    debounce(e => {
      onChange?.(e);
    }, debounceTime),
    [],
  );

  useEffect(() => {
    // Uncontrolled callers pass `defaultValue` and no `value` — syncing would blank the seeded
    // value on mount (CrudTable's search input, seeded from the URL, is one).
    if (externalValue === undefined) return;

    setValue(externalValue);
  }, [externalValue]);

  const handleChange = event => {
    setValue(event.target.value);
    debouncedOnChange(event);
  };

  return <BaseInput {...props} value={value} onChange={handleChange} onBlur={onChange} />;
};
